export const MIXING_BIN_INITIAL_STATE = {
    filter: {
        name: '',
        show: 'active',
    },
    createMixingBinInitial: {
        name: '',
        active: true,
        feedLotId: '',
        capacity: '',
    },
    loader: true,
};
